import { FrameName } from "../config";
import ShallowSeaFishingBoatBuildingTileEntity from "./ShallowSeaFishingBoatBuildingTileEntity";

class DeepSeaFishingBoatBuildingTileEntity extends ShallowSeaFishingBoatBuildingTileEntity {
	public static readonly frameName = FrameName.DEEP_SEA_FISHING_BOAT;
}

export default DeepSeaFishingBoatBuildingTileEntity;
